import React from 'react';
import styled, { keyframes, css } from 'styled-components';
import useTimeout from '../../hooks/useTimeout';
import { select } from '../../core/themev2';
import EstadoWhite from '../../assets/icons/estado-white.svg';
import AlertWhite from '../../assets/icons/alert-circle-white.svg';
import CloseWhite from '../../assets/icons/close-white.svg';

function SnackBar({ component, result, onClose, keepOpen, deviceType, withAlertIcon = true, withoutIcon = false }) {
  useTimeout(keepOpen ? () => {} : onClose, 8000);

  return (
    <SnackBarContainer
      result={result}
      deviceType={deviceType}
      withAlertIcon={withAlertIcon}
      data-panel='snackbar-container'
    >
      <div className='iconAndTextWrapper'>
        {!withoutIcon && <div className='icon' />}
        <div className='text'>{component}</div>
      </div>
      <div className='closeIcon' onClick={onClose} aria-hidden='true' />
    </SnackBarContainer>
  );
}

const fadeIn = keyframes`
  from {
    opacity: 0;
    bottom: -48px;
  }
  to {
    opacity: 1;
    bottom: 4px;
  }
`;

const SnackbarStatus = {
  SUCCESS: 'SUCCESS',
  NEUTRAL: 'NEUTRAL',
  INFO: 'INFO',
  ERROR: 'ERROR'
};

const SnackBarMobile = css`
  min-height: 48px;
  width: calc(100vw - 32px);
  align-self: center;
  border-radius: 4px;
  padding: 10.5px 16px;
  margin: 8px 0 0;
  color: ${select('white')};
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
  background-color: ${({ result }) =>
    // eslint-disable-next-line no-nested-ternary
    result === SnackbarStatus.SUCCESS
      ? select('snackGreen')
      : result === SnackbarStatus.NEUTRAL
      ? select('neutralDarkGrayII')
      : select('feedbackRed')};
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: opacity 0.5s;
  animation: ${fadeIn} 0.5s ease-out forwards;
  opacity: 1;
  .iconAndTextWrapper {
    display: flex;
    align-items: center;
  }
  .icon {
    width: 13px;
    height: 13px;
    margin-right: 9.5px;
    display: ${({ withAlertIcon }) => (withAlertIcon ? 'flex' : 'none')};
    flex-shrink: 0;
    background-image: ${({ result }) => `url(${result === SnackbarStatus.SUCCESS ? EstadoWhite : AlertWhite})`};
    background-repeat: no-repeat;
    background-size: cover;
  }
  .text {
    margin-right: 24px;
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    white-space: normal;
  }
  .closeIcon {
    background-image: ${`url(${CloseWhite})`};
    width: 13px;
    height: 13px;
    flex-shrink: 0;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }
`;

const SnackBarDesktop = css`
  min-height: 48px;
  border-radius: 4px;
  z-index: 100;
  padding: 4px 16px;
  margin: 8px 16px 0;
  color: ${select('white')};
  box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.2);
  background-color: ${({ result }) => {
    if (result === SnackbarStatus.SUCCESS) {
      return select('snackGreen');
    }
    if (result === SnackbarStatus.INFO) {
      return select('neutralDarkGrayII');
    }
    return select('negative');
  }};
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: opacity 0.5s;
  animation: ${fadeIn} 0.5s ease-out forwards;
  opacity: 1;
  .iconAndTextWrapper {
    display: flex;
    align-items: center;
  }
  .icon {
    width: 13px;
    height: 13px;
    margin-right: 9.5px;
    display: ${({ withAlertIcon }) => (withAlertIcon ? 'flex' : 'none')};
    flex-shrink: 0;
    background-image: ${({ result }) => {
      if (result === SnackbarStatus.SUCCESS) {
        return `url(${EstadoWhite})`;
      }
      if (result === SnackbarStatus.INFO) {
        return null;
      }
      return `url(${AlertWhite})`;
    }};
    background-repeat: no-repeat;
    background-size: cover;
  }
  .text {
    max-width: 1000px;
    margin-right: 24px;
    font-family: Hind;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    white-space: normal;
  }
  .closeIcon {
    width: 13px;
    height: 13px;
    flex-shrink: 0;
    background-image: ${`url(${CloseWhite})`};
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;
  }
`;

const SnackBarContainer = styled.span`
  ${({ deviceType }) => (deviceType === 'mobile' ? SnackBarMobile : SnackBarDesktop)}
`;

export default SnackBar;
